<div mat-dialog-title style="float: left; width: 100%; background-color: #002b43; float: left; color:white;">
    <div style="width: 100%; background-color: #002b43; float: left; color:white;">
        <div style="width: 90%; float:left;">
            <div style="margin: 1em;">
                <p class="imgLogo">
                    <img class="imgItem" src="/assets/img/logo Mapix.png">
                </p>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-content>
    <h1 class="title">Recuperar contraseña </h1>
    <div style="margin: 1em; color:lightgrey; font-size:medium; text-align: center;">
        <form [formGroup]="formChangePassword" (ngSubmit)="sendRecoveryMail()">
            <div>
                <mat-form-field class="full-width-input" style="text-align: left; margin-bottom: 1.5em;">
                    <input matInput placeholder="Email" formControlName="email" required
                        type="email" />
                        <mat-icon matSuffix>Correo Electrónico</mat-icon>
                </mat-form-field>
            </div>
            <button class="btnEntrar" type="submit">
                <div>
                  <img class="enter-icon-mobile" src="/assets/img/icon_entrar.png" alt="Image" style="width: 1.3em;">
                </div>
                <div>
                  Cambiar contraseña
                </div>
              </button>
        </form>
    </div>
    <div class="integration">
        <p>Integrado al ecosistema </p>
        <img class="imgItem2" src="/assets/img/logo Mapix.png">
      </div>
</div>